import { setHours, setMinutes } from "date-fns"

import { useUI } from "providers/UIProvider"

import { Box, Grid, GridItem, Flex, Center, Text } from "@chakra-ui/react"

import { ILaundryMainDetailsProps } from "./LaundryTemplateTypes"

import Input from "components/UI/atoms/Input"
import UploadInput from "components/UI/molecules/UploadInput"
import MapInput from "components/UI/molecules/MapInput"
import FormLabel from "components/UI/atoms/FormLabel"
import SelectTime from "components/UI/molecules/SelectTime"
import Select from "components/UI/atoms/Select"
import { ISelectOption } from "types/shared"

const LaundryMainDetails: React.FC<ILaundryMainDetailsProps> = (
  {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setValues,
    handleLogoChange,
    handle24Click,
    handleMapChange,
    logo,
    removeLogo,
    coordinates,
    setCoordinates,
    districtOptions
  }
) => {
  const { T } = useUI()


  const renderLogoHelper = () => (
    <Box>
      <Flex flexDirection="row" gap={1}>
        <Text>
          {T("laundry.form.logo.helper.format")}:{" "}
        </Text>
        <Text color="primary" display="inline" fontWeight="bold">
          {"PNG"}
        </Text>
      </Flex>
      <Flex flexDirection="row" gap={1}>
        <Text>
          {T("laundry.form.logo.helper.size")}:{" "}
        </Text>
        <Text color="primary" display="inline" fontWeight="bold">
          {"500px - 500px"}
        </Text>
      </Flex>
    </Box>
  )

  const handleAfterClick = (coordinates: any) => {
    if (coordinates) {
      setCoordinates({ lat: coordinates?.lat(), lng: coordinates?.lng() })
    }
  }

  const forceTouched = () => {
    touched.logo = true
  }


  return (
    <Box>
      <Grid templateColumns={{ md: "repeat(2, 1fr)" }} gap="25px">
        <GridItem>
          <Input
            id="laundry-name"
            name="name"
            label={T("laundry.form.name_label")}
            value={values.name}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            styles={{ width: "100%", height: "60px" }}
            error={Boolean(errors.name && touched.name)}
            errorMessage={errors.name}
          />
        </GridItem>
        <GridItem>
          <UploadInput
            onClick={forceTouched}
            name="logo"
            label={T("laundry.form.logo_label")}
            accept="image/png"
            value={values.logo}
            error={(errors.logo && touched.logo) && errors.logo || ""}
            onChange={handleLogoChange}
            inputLabel={T("laundry.form.logo_upload")}
            file={logo}
            fileType="IMAGE"
            onRemove={removeLogo}
            inputStyles={{ height: "60px" }}
            helper={renderLogoHelper()}
            imageUrl={logo}
          />
        </GridItem>
        <GridItem display="flex" justifyContent="space-between">
          <Box w="45%">
            <Input
              id="identification-code"
              name="idNumber"
              label={T("laundry.form.identification.code")}
              value={values.idNumber === null ? "" : values.idNumber}
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              styles={{ width: "100%", height: "60px" }}
            // error={Boolean(errors.isNumber && touched.isNumber)}
            // errorMessage={errors.isNumber}
            />
          </Box>
          <Box width="45%">

            <Input
              id="bank-account"
              name="bankAccount"
              label={T("laundry.form.iban")}
              value={values.bankAccount === null ? "" : values.bankAccount}  //////////
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              styles={{ width: "100%", height: "60px" }}
            // error={Boolean(errors.isNumber && touched.isNumber)}
            // errorMessage={errors.isNumber}
            />

          </Box>
        </GridItem>
        <GridItem>
          <MapInput
            name="address"
            label={T("laundry.form.address_label")}
            value={values.address}
            onChange={handleMapChange}
            onBlur={handleBlur}
            inputTouched={Boolean(touched.address)}
            inputStyles={{ width: "100%", height: "60px" }}
            coordinates={coordinates}
            setCoordinates={setCoordinates}
            afterClick={(coordinates: Partial<google.maps.LatLng>) => handleAfterClick(coordinates)}
            error={(errors.address && touched.address) && errors.address || ""}
          />
        </GridItem>
        <GridItem>
          <Input
            id="laundry-phone"
            name="phone"
            label={T("laundry.form.phone_label")}
            value={values.phone}
            type="number"
            onChange={handleChange}
            onBlur={handleBlur}
            styles={{ width: "100%", height: "60px" }}
            error={Boolean(errors.phone && touched.phone)}
            errorMessage={errors.phone}
          />
        </GridItem>
        <GridItem>
          <Input
            id="laundry-email"
            name="email"
            label={T("laundry.form.email_label")}
            value={values.email}
            type="email"
            onChange={handleChange}
            onBlur={handleBlur}
            styles={{ width: "100%", height: "60px" }}
            error={Boolean(errors.email && touched.email)}
            errorMessage={errors.email}
          />
        </GridItem>
        <GridItem>
          <FormLabel
            id="laundry-time"
            text={T("laundry.form.working_hours_label")}
          />
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Text fontSize="base">{T("laundry.form.start_time_label")}</Text>
              <Box ml="12px" mr="20px" width="130px">
                <SelectTime
                  name="startTime"
                  onChange={(_name, date) => setValues({ ...values, startTime: date })}
                  selected={values.startTime}
                  // minTime={setHours(setMinutes(new Date(), 0), 0)}
                  // maxTime={values?.endTime}
                  isDisabled={values.is24 as boolean}
                  inputStyles={{
                    height: "60px",
                    fontSize: "var(--chakra-fontSizes-xl)",
                  }}
                  timeIntervals={30}
                />
              </Box>
              <Text fontSize="base">{T("laundry.form.end_time_label")}</Text>
              <Box ml="12px" mr="15px" width="130px">
                <SelectTime
                  name="endTime"
                  onChange={(_name, date) => setValues({ ...values, endTime: date })}
                  selected={values.endTime}
                  // minTime={values?.startTime}
                  // maxTime={setHours(setMinutes(new Date(), 59), 23)}
                  isDisabled={values.is24 as boolean}
                  inputStyles={{
                    height: "60px",
                    fontSize: "var(--chakra-fontSizes-xl)",
                  }}
                  timeIntervals={30}
                />
              </Box>
            </Flex>
            <Center
              cursor="pointer"
              w="70px"
              h="60px"
              borderRadius="10px"
              fontSize="xl"
              border="2px solid"
              borderColor={
                values.is24 ? "success" : "input_border_color_primary"
              }
              color={values.is24 ? "success" : "main_text_color"}
              onClick={handle24Click}
              transition=".3s ease"
            >
              24h
            </Center>
          </Flex>
        </GridItem>
        <GridItem display="flex" justifyContent="space-between">
          <Box w="40%">
            <Input
              id="laundry-boxes"
              name="boxes"
              label={T("laundry.form.boxes_label")}
              value={values.boxes || ""}
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              styles={{ width: "100%", height: "60px" }}
              error={Boolean(errors.boxes && touched.boxes)}
              errorMessage={errors.boxes}
            />
          </Box>
          <Box w="50%">
            <Select
              label={T("laundry.form.district_label")}
              name="district"
              value={values.district || ""}
              placeholder="აირჩიეთ უბანი"
              onChange={(e: ISelectOption) => setValues({ ...values, district: e.value })}
              onBlur={handleBlur}
              options={districtOptions || []}
              inputStyles={{ width: "100%", height: "60px", fontSize: "var(--chakra-fontSizes-m)", borderColor: "red" }}
              error={(errors.district && touched.district) && errors.district || ""}
            />
          </Box>
        </GridItem>
      </Grid>
    </Box>
  )
}

export default LaundryMainDetails
